var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MultiSelectReact from 'multi-select-react';

var OptionsState = {
  ALLSELECTED: 1,
  NONESELECTED: 2,
  DEFAULT: 0

  //Returns of All the options or none of the options are selected.
};var isAllorNoneSelected = function isAllorNoneSelected(options) {

  if (options.length > 0) {
    var allSelected = true;
    var noneSelected = true;
    options.forEach(function (option) {
      if (option.id !== 'enableAll' && option.id !== 'enableNone') {
        if (option.value === true) noneSelected = false;

        if (option.value === false) allSelected = false;
      }
    });

    if (allSelected) return OptionsState.ALLSELECTED;

    if (noneSelected) return OptionsState.NONESELECTED;
  }

  return OptionsState.DEFAULT;
};

var MarkAllOrNoneOptions = function MarkAllOrNoneOptions(choice, optionList) {

  return optionList.map(function (option) {
    option.value = choice;
    return option;
  });
};

var MultiSelectReactExt = function (_Component) {
  _inherits(MultiSelectReactExt, _Component);

  function MultiSelectReactExt(props) {
    _classCallCheck(this, MultiSelectReactExt);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.optionClicked = function (optionsList) {

      if (_this.isAllNoneEnabled) {
        if (!_this.isAllSelected && optionsList[0].value) {
          return _this.props.optionClicked(MarkAllOrNoneOptions(true, optionsList));
        }

        if (!_this.isNoneSelected && optionsList[optionsList.length - 1].value) {
          return _this.props.optionClicked(MarkAllOrNoneOptions(false, optionsList));
        }
      }

      _this.props.optionClicked(optionsList);
    };

    _this.selectedBadgeClicked = function (optionsList) {

      if (_this.isAllNoneEnabled) {
        if (!_this.isAllSelected && optionsList[0].value) {
          return _this.props.selectedBadgeClicked(MarkAllOrNoneOptions(true, optionsList));
        }

        if (!_this.isNoneSelected && optionsList[optionsList.length - 1].value) {
          return _this.props.selectedBadgeClicked(MarkAllOrNoneOptions(false, optionsList));
        }
      }

      _this.props.selectedBadgeClicked(optionsList);
    };

    _this.shouldComponentUpdate = function (nextProps, _) {
      if (nextProps.options.length > 0 && nextProps.enableSelectAllNone && nextProps.options[0].id !== 'enableAll') {
        _this.isAllNoneEnabled = false;
      }
      return true;
    };

    _this.options = [];
    _this.isAllNoneEnabled = false;
    _this.isAllSelected = false;
    _this.isNoneSelected = false;
    return _this;
  }

  MultiSelectReactExt.prototype.render = function render() {
    var _props = this.props,
        options = _props.options,
        enableSelectAllNone = _props.enableSelectAllNone;

    this.options = options;

    //Add Select all and Select None Options
    if (!this.isAllNoneEnabled && enableSelectAllNone) {
      options = [{ 'label': 'Select All', 'id': 'enableAll', 'value': false }].concat(options.concat([{ 'label': 'Select None', 'id': 'enableNone', 'value': false }]));
      this.isAllNoneEnabled = true;
    }
    //Remove Select all and Select None Options
    if (this.isAllNoneEnabled && !enableSelectAllNone) {
      this.isAllNoneEnabled = false;
    }

    //mark SelectAll or Select None Options of all other or no other was selected respectively
    if (this.isAllNoneEnabled) {
      var selectedOption = isAllorNoneSelected(options);
      this.isAllSelected = selectedOption === OptionsState.ALLSELECTED;
      this.isNoneSelected = selectedOption === OptionsState.NONESELECTED;
      options[0].value = selectedOption === OptionsState.ALLSELECTED;
      options[options.length - 1].value = selectedOption === OptionsState.NONESELECTED;
    }

    return React.createElement(MultiSelectReact, _extends({}, this.props, {
      options: options,
      optionClicked: this.optionClicked,
      selectedBadgeClicked: this.selectedBadgeClicked
    }));
  };

  return MultiSelectReactExt;
}(Component);

MultiSelectReactExt.propTypes = process.env.NODE_ENV !== "production" ? {
  enableSelectAllNone: PropTypes.bool
} : {};

export default MultiSelectReactExt;